import { render } from "./Monitor.vue?vue&type=template&id=bcd9b340&scoped=true"
import script from "./Monitor.vue?vue&type=script&lang=js"
export * from "./Monitor.vue?vue&type=script&lang=js"

import "./Monitor.vue?vue&type=style&index=0&id=bcd9b340&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd9b340"]])

export default __exports__